export default "__VITE_ASSET__CIpigXmT__"